import useCompanyTimeSeries from '@/pages/CompanyReport/components/Past/hooks/useCompanyTimeSeries';
import { useCompanyCanonicalUrl } from '@/hooks/useCompany';
import ChartWrapper from '@/pages/CompanyReport/components/Overview/components/ChartWrapper';
import ReportSubSection from '@/components/ReportSubSection/ReportSubSection';
import { FreeCashFlowChart } from './components/FreeCashFlowChart/FreeCashFlowChart';
import loadable from '@loadable/component';
import { useTracking } from 'react-tracking';

const FreeCashFlowTable = loadable(
  () => import('./components/FreeCashFlowTable')
);

export const FreeCashFlow = () => {
  const canonicalUrl = useCompanyCanonicalUrl();
  const { data, status } = useCompanyTimeSeries({
    canonicalUrl,
    period: 'MAX',
  });
  const title = 'Free Cash Flow vs Earnings Analysis';
  useTracking({ modifier: title, action: 'viewed' }, { dispatchOnMount: true });

  return (
    <ReportSubSection
      title={title}
      trackingProps={{ subject: 'chart' }}
      bodyRender={() => (
        <ChartWrapper
          preRenderHeight={350}
          id="free-cash-flow-chart"
          isLoading={status === 'pending'}
          chart={<FreeCashFlowChart rawData={data} status={status} />}
          hideTableScrollbars
          table={<FreeCashFlowTable rawData={data} />}
        />
      )}
    />
  );
};
